export interface PresetSettingStoreState {
  isPresetSettingDisplayed: boolean;
}

export const initPresetSettingStoreState: PresetSettingStoreState = {
  isPresetSettingDisplayed: false,
};
